import styled from '@emotion/styled'
import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

interface RichTextEditorProps {
    value: string
    onChange: (value: string) => void
    placeholder?: string
    disabled?: boolean
    minHeight?: number
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
    value,
    onChange,
    placeholder,
    disabled = false,
    minHeight = 100,
}) => {
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            ['link'],
            ['clean'],
        ],
    }

    const formats = [
        'bold', 'italic', 'underline', 'strike',
        'blockquote', 'code-block',
        'list', 'bullet',
        'script',
        'indent',
        'link'
    ]

    return (
        <StyledQuill
            theme="snow"
            value={value || ''}
            onChange={onChange}
            modules={modules}
            formats={formats}
            placeholder={placeholder}
            readOnly={disabled}
            style={{ minHeight: `${minHeight}px` }}
        />
    )
}

const StyledQuill = styled(ReactQuill)`
    .ql-toolbar {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        border-color: #dee2e6;
    }

    .ql-container {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        border-color: #dee2e6;
        font-family: inherit;
    }

    .ql-editor {
        font-size: 14px;
        
        &.ql-blank::before {
            font-style: italic;
            color: #adb5bd;
        }
    }

    &.ql-disabled {
        .ql-toolbar {
            border-color: #e9ecef;
            background-color: #f8f9fa;
        }
        
        .ql-container {
            border-color: #e9ecef;
            background-color: #f8f9fa;
        }
    }
`

export default RichTextEditor
